import React, { useState, useEffect } from 'react';
import { profileStore } from 'src/hooks/profile';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import Profile from '@system/config/profile';
import { __set, __remove } from "../../store/axios_indicator";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';

const LinkToExistingAccount = () => {
    const {
        phoneNumberPattern,
        apacCompanyNamePattern,
        japanCompanyNamePattern,
        addressAsiaCheckoutPattern,
        addressJapanCheckoutPattern,
        registerEmailPattern,
        japanFirstNamePattern,
        apacFirstNamePattern,
        houseNumPattern,
        ProfileTab: { ProfileInfo },
        speedBoats: { japanAbbr } } = Constants
    const companyNamePattern = System.getCurrentRegionWithType(japanAbbr) ? japanCompanyNamePattern : apacCompanyNamePattern
    const addressPattern = System.getCurrentRegionWithType(japanAbbr) ? addressJapanCheckoutPattern : addressAsiaCheckoutPattern
    const firstNamePattern = System.getCurrentRegionWithType(japanAbbr) ? japanFirstNamePattern : apacFirstNamePattern

    const [{ profile_user_information, countryList }, { get_profile_account_information, get_country_list }, { set_account_link_data }] = profileStore();
    const [accountData, setAccountData] = useState({
        accountNumber: "",
        companyName: "",
        representativeName: "",
        address1: "",
        representativeEmail: "",
        address2: "",
        representativeNumber: "",
        city: "",
        zip: "",
        country: "",
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        address3: "",
        houseNum: "",
        district: "",
    })
    const [__check] = useAxiosIndicatorCheck();

    const [accountValidation, setAccountValidation] = useState({});
    const { translation: t } = System;

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
            await get_country_list()
        }
        fetchHere()
    }, [])

    useEffect(() => {
        setAccountData(prevState => ({
            ...prevState,
            firstName: profile_user_information?.firstName,
            lastName: profile_user_information?.lastName,
            email: profile_user_information?.emailAddress,
            mobileNumber: profile_user_information?.mobileNumber,
        }))
    }, [profile_user_information])

    const goBack = () => {
        window.location.href = Profile.getProfileURL() + `?tab=${ProfileInfo}`;
    }

    const onAccountValueChange = (field, value) => {
        setAccountData(prevState => ({ ...prevState, [field]: value }));
    };

    const onValidateAccountData = async () => {
        let validationModal = {};
        if (Helper.valueIsNotNull(accountData.representativeEmail) && !Helper.validateRegex(accountData.representativeEmail, registerEmailPattern)) {
            validationModal.representativeEmail = t('aValidEmailAddressIsRequired');
        }
        if (Helper.valueIsNotNull(accountData.representativeNumber) && !Helper.validateRegex(accountData.representativeNumber, phoneNumberPattern)) {
            validationModal.representativeNumber = t('pleaseEnterAValidPhoneNumber');
        }
        if (Helper.valueIsNotNull(accountData.companyName) && !Helper.validateRegex(accountData.companyName, companyNamePattern)) {
            validationModal.companyName = t('companyNameEnglishValidation');
        }
        if (Helper.valueIsNotNull(accountData.representativeName) && !Helper.validateRegex(accountData.representativeName, firstNamePattern)) {
            validationModal.representativeName = t('firstNameEnglishValidation');
        }
        if (Helper.valueIsNotNull(accountData.city) && !Helper.validateRegex(accountData.city, addressPattern)) {
            validationModal.city = t('validCityRequired');
        }
        if (Helper.valueIsNotNull(accountData.address1) && !Helper.validateRegex(accountData.address1, addressPattern)) {
            validationModal.address1 = t('validAddressRequired');
        }
        if (Helper.valueIsNotNull(accountData.address2) && !Helper.validateRegex(accountData.address2, addressPattern)) {
            validationModal.address2 = t('validAddressRequired');
        }
        if (Helper.valueIsNotNull(accountData.zip) && !System.validatePostalCode(accountData.zip, accountData?.country)) {
            validationModal.zip = t('validZipCodeRequired');
        }
        if ((Helper.valueIsNotNull(accountData.houseNum)) && (!Helper.validateRegex(accountData.houseNum, houseNumPattern))) {
            validationModal.houseNumber = t('validHouseNumber');
        }
        if ((Helper.valueIsNotNull(accountData.address3)) && ((!Helper.validateRegex(accountData.address3, addressPattern)))) {
            validationModal.address3 = t('validAddressRequired');
        }
        if ((Helper.valueIsNotNull(accountData.district)) && ((!Helper.validateRegex(accountData.district, houseNumPattern)))) {
            validationModal.district = t('validDistrict');
        }
        setAccountValidation(validationModal);
        Helper.scrollTop()
        return Object.keys(validationModal).length === 0;
    };

    const onSave = async () => {
        let isValid = await onValidateAccountData();
        if (isValid) {
            const accountParams = {
                accountNumber: accountData?.accountNumber,
                avnetRepresentativeName: accountData?.representativeName,
                avnetRepresentativeEmail: accountData?.representativeEmail,
                avnetRepresentativePhone: accountData?.representativeNumber,
                company: accountData?.companyName,
                addressLineOne: accountData?.address1,
                addressLineTwo: accountData?.address2,
                addressLineThree: accountData?.address3,
                city: accountData?.city,
                postalCode: accountData?.zip,
                state: accountData?.state,
                country: accountData?.countryName,
                firstName: accountData?.firstName || "",
                lastName: accountData?.lastName || "",
                phoneNumber: accountData?.mobileNumber || "",
                email: accountData?.email || "",
                houseNum: accountData?.houseNum || "",
                district: accountData?.district || "",
            }

            __set('SET_ACCOUNT_LINK_DATA')
            const data = await set_account_link_data(accountParams)
            if (data?.isSuccessFull) {
                sessionStorage.setItem(System?.storageName?.ACCOUNT_LINK_SUCCESS_MESSAGE, true)
                goBack()
            }
            __remove('SET_ACCOUNT_LINK_DATA')
        }
    };

    return (
        <>
            <div className='container profile-container linktoexisting mb-5'>
                <div className="page-title font-oswald font-light font-38 mb-3 mb-sm-0">{t('linkToExistingAccount')}</div>
                <div className="bs5 row mt-2">
                </div>
                <hr />
                <p className='pt-2 pb-2'>{t('linkExistingAccountTermsInfo')}</p>
                <hr />

                <form>
                    <div className="font-weight-normal font-24 mb-1">{t('linkToExistingAccountDetails')}</div>
                    <p className="font-13 font-arial mb-3">{t('linkExistingAccountDetails')}</p>

                    <div className="bs5 row mt-2">
                        <div className="col-md-5">
                            <div className='bs5 row'>
                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="accountNumber" className="d-block">{t('accountNumber')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.accountNumber ? "error" : ""}`}
                                            id="accountNumber"
                                            placeholder={t('accountNumber')}
                                            name="accountNumber"
                                            maxLength={10}
                                            value={accountData.accountNumber}
                                            onChange={({ target: { value } }) => onAccountValueChange("accountNumber", value)}
                                        />
                                        {accountValidation.accountNumber && <p className="error">{accountValidation.accountNumber}</p>}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="representativeName" className="d-block">{t('avnetRepresentativeName')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.representativeName ? "error" : ""}`}
                                            id="representativeName"
                                            placeholder={t('name')}
                                            name="representativeName"
                                            maxLength={35}
                                            value={accountData.representativeName}
                                            onChange={({ target: { value } }) => onAccountValueChange("representativeName", value)}
                                        />
                                        {accountValidation.representativeName && <p className="error">{accountValidation.representativeName}</p>}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="representativeEmail" className="d-block">{t('avnetRepresentativeEmail')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.representativeEmail ? "error" : ""}`}
                                            id="representativeEmail"
                                            placeholder={t('emailAddress')}
                                            name="representativeEmail"
                                            maxLength={70}
                                            value={accountData.representativeEmail}
                                            onChange={({ target: { value } }) => onAccountValueChange("representativeEmail", value)}
                                        />
                                        {accountValidation.representativeEmail && <p className="error">{accountValidation.representativeEmail}</p>}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="representativeNumber" className="d-block">{t('avnetRepresentativePhoneNumber')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.representativeNumber ? "error" : ""}`}
                                            id="representativeNumber"
                                            placeholder={t('phoneNumber')}
                                            name="representativeNumber"
                                            maxLength={25}
                                            value={accountData.representativeNumber}
                                            onChange={({ target: { value } }) => onAccountValueChange("representativeNumber", value)}
                                        />
                                        {accountValidation.representativeNumber && <p className="error">{accountValidation.representativeNumber}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className='bs5 row'>
                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="companyName" className="d-block">{t('companyName')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.companyName ? "error" : ""}`}
                                            id="companyName"
                                            placeholder={t('companyName')}
                                            name="companyName"
                                            maxLength={System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? 70 : 35}
                                            value={accountData.companyName}
                                            onChange={({ target: { value } }) => onAccountValueChange("companyName", value)}
                                        />
                                        {accountValidation.companyName && <p className="error">{accountValidation.companyName}</p>}
                                    </div>
                                </div>

                                {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="houseNumber" className="d-block">{t('houseNumber')}</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.houseNumber ? "error" : ""}`}
                                                id="houseNumber"
                                                placeholder={t('houseNumber')}
                                                name="houseNumber"
                                                maxLength={6}
                                                value={accountData.houseNum}
                                                onChange={({ target: { value } }) => onAccountValueChange("houseNum", value)}
                                            />
                                            {accountValidation.houseNumber && <p className="error">{accountValidation.houseNumber}</p>}
                                        </div>
                                    </div>
                                }
                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="address1" className="d-block">{t('address1')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.address1 ? "error" : ""}`}
                                            id="address1"
                                            placeholder={t('address1')}
                                            name="address1"
                                            maxLength={35}
                                            value={accountData.address1}
                                            onChange={({ target: { value } }) => onAccountValueChange("address1", value)}
                                        />
                                        {accountValidation.address1 && <p className="error">{accountValidation.address1}</p>}
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="address2" className="d-block">{t('address2')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.address2 ? "error" : ""}`}
                                            id="address2"
                                            placeholder={t('address2')}
                                            name="address2"
                                            maxLength={35}
                                            value={accountData.address2}
                                            onChange={({ target: { value } }) => onAccountValueChange("address2", value)}
                                        />
                                        {accountValidation.address2 && <p className="error">{accountValidation.address2}</p>}
                                    </div>
                                </div>

                                {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="address3" className="d-block">{t('address3')}</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.address3 ? "error" : ""}`}
                                                id="address3"
                                                placeholder={t('address3')}
                                                name="address3"
                                                maxLength={35}
                                                value={accountData.address3}
                                                onChange={({ target: { value } }) => onAccountValueChange("address3", value)}
                                            />
                                            {accountValidation.address3 && <p className="error">{accountValidation.address3}</p>}
                                        </div>
                                    </div>
                                }

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="city" className="d-block">{t('city')}</label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${accountValidation.city ? "error" : ""}`}
                                            id="city"
                                            placeholder={t('city')}
                                            name="city"
                                            maxLength={35}
                                            value={accountData.city}
                                            onChange={({ target: { value } }) => onAccountValueChange("city", value)}
                                        />
                                        {accountValidation.city && <p className="error">{accountValidation.city}</p>}
                                    </div>
                                </div>

                                {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                    <div className="col-12">
                                        <div className="form-group w-90">
                                            <label htmlFor="district" className="d-block">{t('district')}</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.district ? "error" : ""}`}
                                                id="district"
                                                placeholder={t('district')}
                                                name="district"
                                                maxLength={35}
                                                value={accountData.district}
                                                onChange={({ target: { value } }) => onAccountValueChange("district", value)}
                                            />
                                            {accountValidation.district && <p className="error">{accountValidation.district}</p>}
                                        </div>
                                    </div>
                                }
                                <div className="bs5 row">
                                    <div className="col-md-6 pe-0">
                                        <div className="form-group  w-90">
                                            <label htmlFor="state" className="d-block">{t('stateProvidence')}</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.state ? "error" : ""}`}
                                                id="state"
                                                placeholder={t('stateProvidence')}
                                                name="state"
                                                maxLength={60}
                                                value={accountData.state}
                                                onChange={({ target: { value } }) => onAccountValueChange("state", value)}
                                            />
                                            {accountValidation.state && <p className="error">{accountValidation.state}</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-0">
                                        <div className="form-group  w-90">
                                            <label htmlFor="zip" className="d-block">{t('zipPostalCode')}</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${accountValidation.zip ? "error" : ""}`}
                                                id="zip"
                                                placeholder={t('zipPostalCode')}
                                                name="zip"
                                                maxLength={System.getZipCodeLength(accountData.country)}
                                                value={accountData.zip}
                                                onChange={({ target: { value } }) => onAccountValueChange("zip", value)}
                                            />
                                            {accountValidation.zip && <p className="error">{accountValidation.zip}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group w-90">
                                        <label htmlFor="country" className="d-block">{t('country')}</label>
                                        <div className="selectbox">
                                            <select
                                                className={`form-control form-control-sm ${accountValidation.country ? "error" : ""}`}
                                                name="country"
                                                value={accountData.country}
                                                onChange={({ target: { value } }) => {
                                                    const selectedCountry = countryList.find(c => c.countryCode === value);
                                                    onAccountValueChange("country", value);
                                                    onAccountValueChange("countryName", selectedCountry?.countryName || "");
                                                }}
                                            >
                                                <option value="">{t('countryName')}</option>
                                                {countryList?.map((v, i) => (<option key={v.countryId}
                                                    value={v.countryCode}>{v.countryName}</option>))}
                                            </select>
                                            {accountValidation.country && <p className="error">{accountValidation.country}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />
                    <div className="page-title font-oswald font-light font-24 mb-1">{t('personalDetails')}</div>
                    <p className="font-13 font-arial mb-3">{t('personalDetailsareNotEditable')}</p>

                    <div className="bs5 row">
                        <div className="col-md-5">
                            <div className="form-group w-90">
                                <label htmlFor="firstName" className="d-block">{t('firstName')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                    id="firstName"
                                    placeholder={t('firstName')}
                                    name="firstName"
                                    defaultValue={accountData.firstName}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="bs5 row">
                        <div className="col-md-5">
                            <div className="form-group w-90">
                                <label htmlFor="lastName" className="d-block">{t('lastName')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                    id="lastName"
                                    placeholder={t('firstName')}
                                    name="lastName"
                                    defaultValue={accountData.lastName}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="bs5 row">
                        <div className="col-md-5">
                            <div className="form-group w-90">
                                <label htmlFor="phoneNumber" className="d-block">{t('phoneNumber')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                    id="phoneNumber"
                                    placeholder={t('phoneNumber')}
                                    name="phoneNumber"
                                    defaultValue={accountData.mobileNumber}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="bs5 row">
                        <div className="col-md-5">
                            <div className="form-group w-90">
                                <label htmlFor="email" className="d-block">{t('email')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    className={`form-control form-control-sm cursor-not-allowed readonly-field`}
                                    id={t('email')}
                                    placeholder="Email Address"
                                    name="email"
                                    defaultValue={accountData.email}
                                />
                            </div>
                        </div>
                    </div>

                    <hr />
                    <button type="button" className="bs5 btn btn-primary me-3 minw150" onClick={onSave}>
                        {__check(['SET_ACCOUNT_LINK_DATA']).status ?
                            <i className="fa fa-spinner fa-spin" /> :
                            <span>{t('submit')}</span>}
                    </button>
                    <button type="button" className="bs5 btn btn-secondary minw150" onClick={goBack}>{t('cancel')}</button>
                </form>
            </div>
        </>
    )
}
export default LinkToExistingAccount;